import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class GiosgChatResource extends BaseCamelCasedResource {
    pk() {
        return "GiosgConfig";
    }
}
GiosgChatResource.urlRoot = legacyApiResourceUrl("GiosgChat");
//# sourceMappingURL=GiosgChatResource.js.map